import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const menuItemTheme: Pick<Components<Theme>, 'MuiMenuItem'> = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        variants: [
          {
            props: { dense: true },
            style: {
              // override MUI style to account for fontawesome icons
              [`& .MuiListItemIcon-root .svg-inline--fa`]: {
                fontSize: '1rem',
              },
            },
          },
        ],
      },
    },
  },
};
